import { Component } from '@angular/core';

@Component({
  selector: 'app-metodosdepago',
  standalone: true,
  imports: [],
  templateUrl: './metodosdepago.component.html',
  styleUrl: './metodosdepago.component.scss'
})
export class MetodosdepagoComponent {

}
